import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const ITEMS = [
  "360° Room Tours",
  "Drone Flights",
  "Promo Clips",
  "Custom-Made for Your Brand",
  "48-Hour Turnaround",
  "Trusted by 20+ Teams",
];

export const TrustMarquee = () => (
  <div className="relative -rotate-1 border-y-2 border-hero-black bg-hero-black py-4" data-testid="trust-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover aria-label="Video types and trust signals">
      {ITEMS.map((item, i) => (
        <span key={item} className="mx-6 inline-flex items-center gap-6">
          <span className={`font-display text-lg font-semibold uppercase tracking-[0.2em] ${i % 2 ? "text-hero-gold" : "text-white"}`}>
            {item}
          </span>
          <Star className="h-4 w-4 fill-hero-gold text-hero-gold" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
